import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=7973a1bb&scoped=true&"
import script from "./AppVersion.vue?vue&type=script&lang=js&"
export * from "./AppVersion.vue?vue&type=script&lang=js&"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=7973a1bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973a1bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
